import Router from 'next/router';
import googleAnalytics from '@analytics/google-analytics';
import googleTagManager from '@analytics/google-tag-manager';
import Analytics from 'analytics';

export const GA_TRACKING_ID = 'G-VPLJCWLXVT';
export const GTM_TRACKING_ID = 'GTM-MQX6L7F9';

// Initialize analytics and plugins
// Documentation: https://getanalytics.io
export const analytics = Analytics({
  debug: process.env.NODE_ENV !== 'production',
  plugins: [
    googleTagManager({
      containerId: GTM_TRACKING_ID,
    }),
    googleAnalytics({
      measurementIds: [GA_TRACKING_ID],
    }),
  ],
});

// Track initial pageview
if (typeof window !== 'undefined') {
  analytics.page();
}

// Track pageview on route change
Router.events.on('routeChangeComplete', (url) => {
  analytics.page();
});

export default analytics;
